import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filter',
})
export class FilterPipe implements PipeTransform {
  transform(items: any[], filterField: string, filterString: string): any[] {
    

    if (!filterField || !filterString) return items;
    let filteredItems = items.filter((el) => {
      return (
        (el?.[filterField] &&
          el[filterField].toLowerCase().includes(filterString.toLowerCase())) ||
        el.EmployerType == 77
      );
    });

    return filteredItems;
  }
}
